// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"0fb04d26","202":"ecc051a5","339":"a5e0d5ea","362":"44baed51","394":"e98ff844","476":"28a6742c","488":"0655f4f6","545":"29923ffe","549":"e1b83067","630":"30d8fb0a","660":"0f1c7656","950":"a8816860"}[chunkId] + ".chunk.js";
};